/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { FuturesTradeAccountSummaryResponse } from './data-contracts';
import { HttpClient, RequestParams } from './http-client';

export class FuturesTradeAccountsSummaries<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name GetFuturesTradeAccountsSummary
   * @request GET:/futuresTradeAccounts-summaries
   * @secure
   */
  getFuturesTradeAccountsSummary = (params: RequestParams = {}) =>
    this.request<FuturesTradeAccountSummaryResponse, any>({
      path: `/futuresTradeAccounts-summaries`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsFuturesTradeAccountsSummaries
   * @request OPTIONS:/futuresTradeAccounts-summaries
   */
  optionsFuturesTradeAccountsSummaries = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/futuresTradeAccounts-summaries`,
      method: 'OPTIONS',
      ...params,
    });
}
